import * as React from "react";
import NotificationComponent from "../Notification/Notification";
import styles from "./styles.module.scss";
import Notification from "@blacknut/javascript-sdk/dist/model/Notification";
export interface NotificationsProps {
  notifications: Notification[];
  renderNotification?: (n: Notification) => JSX.Element;
  clearNotification?: (n: Notification) => void;
}
const Notifications = ({
  notifications,
  renderNotification,
  clearNotification,
}: NotificationsProps) => {
  const onClick = React.useCallback(
    (n: Notification) => {
      clearNotification && clearNotification(n);
    },
    [clearNotification]
  );

  return (
    <div className={styles.list}>
      {notifications.map((n) => {
        return (
          <div
            className={styles.notification}
            key={`${n.localizedMessage || n.message}-${n.time}`}
            onClick={() => onClick(n)}
          >
            {renderNotification && renderNotification(n)}
            {!renderNotification && <NotificationComponent notification={n} />}
          </div>
        );
      })}
    </div>
  );
};

export { Notifications };
export default Notifications;
